<template>
	<form class="uk-form-stacked" @submit="onSubmit" novalidate autocomplete="off">

		<h3 v-html="labels['step1Title']"></h3>

		<p class="kmc-color-dark">* Mandatory fields</p>
		<fieldset class="uk-fieldset uk-margin-medium-bottom">

			<kmc-solicitor-search v-bind="fields.solicitorDetailSearch"
								  :name="'solicitorDetailSearch'"
								  v-model="selectedSolicitor"
								  v-model:textInputValue="solicitorSearchNumber"
								  @select="onSolicitorSelect"
								  @setSolicitorErrorMessage="setSolicitorErrorMessage"/> 

			<kmc-input-checkboxtest class="kmc-form-control  uk-display-block uk-width-1-1"
									:name="'solicitorScotlandNIreland'"
									v-bind="fields['solicitorScotlandNIreland']"
									:solicitorErrorMessage="solicitorErrorMessage"
									:disabled="values['solicitorScotlandNIrelandDisable']"
									@change="onSolicitorManualEntryChange" />

			<kmc-input-checkboxtest class="kmc-form-control  uk-display-block uk-width-1-1"
									:name="'solicitorNotaMember'"
									v-bind="fields['solicitorNotaMember']"
									:disabled="values['solicitorNotaMemberDisable']"
									@change="onSolicitorNotaMemberChange" />

			<div :style="{ 'display' :  values['solicitorNotaMember'] ? 'block' :'none'}">
				<p v-html="labels['nonMemberContent']"></p>
			</div>
			<div :style="{ 'display' :  values['solicitorNotaMember'] ? 'none' :'block'}">
				<div :style="{ 'display' :  values['solicitorScotlandNIreland'] || (values['solicitorDetail'] && values['solicitorDetail']['officeId'] && !values['solicitorDetail']['isVerified']) ? 'block' :'none'}">

					<p v-html="labels['solicitorScotlandNIrelandDescription']"></p>

					<kmc-input-text class="kmc-form-control uk-display-block uk-width-1-1"
									:name="'solicitorDetail.lawAssociationName'"
									v-bind="fields['solicitorDetail']['fields']['lawAssociationName']" />

					<kmc-input-text v-for="i in [1,2,3,4]"
									class="kmc-form-control uk-display-block uk-width-1-1"
									:name="'solicitorDetail.addressLine'+i"
									v-bind="fields['solicitorDetail']['fields']['addressLine'+i]" />

					<kmc-input-text class="kmc-form-control uk-display-block uk-width-1-1"
									:name="'solicitorDetail.town'"
									v-bind="fields['solicitorDetail']['fields']['town']" />

					<kmc-input-postcode class="kmc-form-control uk-display-block uk-width-1-1"
										:name="'solicitorDetail.postcode'"
										v-bind="fields['solicitorDetail']['fields']['postcode']" />

				</div>

				<kmc-input-text v-bind="fields.solicitorDetail && fields.solicitorDetail['fields']['email']"
								class="kmc-form-control uk-display-block uk-width-1-1"
								:name="'solicitorDetail.email'"
								:inputmode="'email'" />

				<kmc-input-text v-bind="fields.solicitorDetail && fields.solicitorDetail['fields']['telephoneNo']"
								class="kmc-form-control uk-display-block uk-width-1-1"
								:name="'solicitorDetail.telephoneNo'"
								:inputmode="'tel'" />

				<kmc-input-text v-bind="fields.solicitorDetail && fields.solicitorDetail['fields']['reference']"
								class="kmc-form-control uk-display-block uk-width-1-1"
								:name="'solicitorDetail.reference'" />
			</div>
		</fieldset>


		<div :style="{ 'display' :  values['solicitorNotaMember'] ? 'none' :'block'}">

			<h3 v-html="labels['step2Title']"></h3>
			<p v-html="labels['step1Description']"></p>

			<p class="kmc-color-dark">* Mandatory fields</p>

			<fieldset class="uk-fieldset">
				<kmc-input-dropdown class="kmc-form-control uk-display-block"
									v-bind="fields.redemptionReasonCode"
									:name="'redemptionReasonCode'" />

			</fieldset>

			<fieldset class="uk-fieldset">
				<kmc-input-text class="kmc-form-control uk-display-block uk-width-1-1"
								:name="'mortgageNumber'"
								v-bind="fields.mortgageNumber" />
			</fieldset>

			<fieldset class="uk-fieldset" v-for="(item, idx) of customers">
				<kmc-input-text v-for="(field, k) in item"
								class="kmc-form-control uk-display-block uk-width-1-1"
								:name="'customerDetails['+idx+'].'+k"
								:label="makeCustomerDetailsLabel(idx,field)"
								:help-text="field.helpText"
								:value="field.value"
								:min-length="field.minLength"
								:max-length="field.maxLength" />
				<button class="uk-button uk-button-link uk-width-1-1 uk-text-right" @click="removeCustomer(idx)" v-if="idx"><span uk-icon="icon: trash"></span> {{ labels['removeCustomerBtnLabel'] }}</button>
			</fieldset>

			<div class="uk-margin uk-margin-medium-bottom">
				<button type="button" class="uk-button uk-button-primary" @click="addCustomer()" v-html="labels['addCustomerBtnLabel']" v-if="customers.length < 4" />
			</div>

			<p v-html="labels['securityAddressMessage']"></p>

			<fieldset class="uk-fieldset">

				<kmc-input-text v-for="i of [1,2,3]"
								class="kmc-form-control uk-display-block uk-width-1-1"
								:name="'propertyDetail.addressLine'+i"
								v-bind="fields['propertyAddressLine'+i]" />

				<kmc-input-text class="kmc-form-control uk-display-block uk-width-1-1"
								:name="'propertyDetail.town'"
								v-bind="fields.propertyTown" />

				<kmc-input-postcode class="kmc-form-control uk-display-block uk-width-1-1"
									:name="'propertyDetail.postcode'"
									v-bind="fields.propertyPostcode" />

			</fieldset>

			<kmc-input-checkbox class="kmc-form-control uk-display-block uk-width-1-1"
								v-bind="fields['confirmation']"
								:name="'confirmation'" />
			
			<div class="uk-alert uk-alert-danger uk-border-rounded" v-if="!isValid && submitCount" v-html="labels['formGenericErrorMessage']" />

			<div class="uk-alert uk-alert-danger uk-border-rounded" v-if="submitErrorMessage && isValid && submitCount" v-html="submitErrorMessage"></div>

			<div class="uk-alert uk-alert-primary uk-border-rounded" v-if="redeemedMessage">
				<p>We're sorry, we've been unable to process this request.</p>
				<p v-html="redeemedMessage"></p>
			</div>

			<div v-if="loading" class="uk-text-center">
				<div uk-spinner="ratio: 2"></div>
			</div>

			<div class="uk-margin uk-margin-medium-bottom">
				<button type="submit" class="uk-button uk-button-primary uk-width-1-1" v-html="labels['submitBtnLabel']" />
			</div>

		</div>

	</form>

	<details v-if="isDebug">
		<summary>Debug form state</summary>
		<pre class="uk-text-small">
        Valid: {{ isValid }}
        Values: {{ values }}
      </pre>
		<pre class="uk-text-small kmc-color-3">
        Errors: {{ errors }}
      </pre>
	</details>


</template>

<script>

	import * as Yup from "yup"
	import { useForm, useFormErrors, useFormValues, useIsFormValid } from "vee-validate"
	import { onMounted, ref } from 'vue'
	import { KmcInputCheckbox, KmcInputCheckboxtest, KmcInputCurrency, KmcInputDropdown, KmcInputPostcode, KmcInputRadio, KmcInputRadioButtons, KmcInputSelect, KmcInputText, KmcSolicitorSearch } from "../components"
	import { useKmcForms } from "./index"
	import { alpha, alphanumWithSpecial, phoneLocalOnly, postcode } from "../validations"
	import { getReCaptchaToken } from "../util"

	export default {
		name: "RedemptionStatementRequest",
		components: { KmcSolicitorSearch, KmcInputDropdown, KmcInputRadio, KmcInputRadioButtons, KmcInputCurrency, KmcInputPostcode, KmcInputText, KmcInputCheckbox, KmcInputCheckboxtest, KmcInputSelect },
		props: {
			data: Object
		},
		setup(props, context) {

			const fields = props.data.fields || {} //from SF json definition
			const labels = props.data.labels || {} //from SF json definition

			const schema = ref({})
			const { handleSubmit, setErrors, errors, handleReset, isSubmitting, meta, setValues, setFieldValue, submitCount, resetForm } = useForm({ validationSchema: schema })
			const { setSchema, applyDefaultValues } = useKmcForms(fields, schema, { setFieldValue, setValues })

			const isDebug = ref(window['sfEnv']['isDebug']);

			const isValid = useIsFormValid()
			const values = useFormValues()
			const errs = useFormErrors()

			const selectedSolicitor = ref()
			const solicitorScotlandNIreland = ref()
			const solicitorSearchNumber = ref()
			const solicitorNotaMember = ref()
			const solicitorNotaMemberDisable = ref()
			const solicitorScotlandNIrelandDisable = ref()
			const solicitorErrorMessage = ref()

			const loading = ref(false)
			const submitErrorMessage = ref()
			const redeemedMessage = ref()

			const solicitorDetailErrorMessage = labels['solicitorDetailErrorMessage']
			const invalidMortgageAccountNumberMessage = labels['invalidMortgageAccountNumberMessage']
			const formAgreementErrorMessage = labels['formAgreementErrorMessage']
			const formSubmitErrorMessage = labels['formSubmitErrorMessage']

			const reset = function () {
				resetForm({ values: {} })
				solicitorErrorMessage.value = ''
				selectedSolicitor.value = null
				solicitorSearchNumber.value = ''
				solicitorNotaMember.value = ''
				solicitorScotlandNIreland.value = ''
			}

			const onSubmit = handleSubmit(async (values) => {
				if (loading.value) return;

				try {
					loading.value = true
					submitErrorMessage.value = ''
					redeemedMessage.value = ''

					const token = await getReCaptchaToken();
					const search = new URLSearchParams({ token })

					values['originatorRequest'] = 'Kensington';

					const response = await fetch(`${location.pathname}/SubmitRequest?${search}`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify(values)
					});

					if (!response.ok) {
						// noinspection ExceptionCaughtLocallyJS
						throw response.statusText + response.status
					}

					const data = await response.json()

					if (data['message'] && data['isRedeemed']) {
						redeemedMessage.value = data['message']
					} else if (data['id']) {
						reset()
						document.location.pathname = document.location.pathname + '/thank-you'
					} else {
						// noinspection ExceptionCaughtLocallyJS
						throw data
					}

				} catch (e) {
					submitErrorMessage.value = formSubmitErrorMessage
					console.error('API Error', e);
				} finally {
					loading.value = false
				}
			})

			const requiredWhenNotVerified = (yup) => yup.when('isVerified',
				{
					is: true,
					then: alphanumWithSpecial().notRequired().nullable(),
					otherwise: alphanumWithSpecial().required()
				}
			)

			setSchema({
				redemptionReasonCode: Yup.string().required(),
				mortgageNumber: Yup.string().test('is-account-number', invalidMortgageAccountNumberMessage, val => (/^R?[0-9]{10}$/i).test(val)).required(),
				customerDetails: Yup.array().of(Yup.object({
					firstName: alpha().required(),
					lastName: alpha().required(),
				})).min(1).max(4).required(),
				propertyDetail: Yup.object({
					addressLine1: alphanumWithSpecial().required(),
					addressLine2: alphanumWithSpecial().notRequired().nullable(),
					addressLine3: alphanumWithSpecial().notRequired().nullable(),
					town: alpha().required(),
					postcode: postcode().required(),
				}).required(),
				solicitorDetailSearch: Yup.object().notRequired().nullable(),
				solicitorScotlandNIreland: Yup.boolean().when(['solicitorDetailSearch', 'solicitorNotaMember'], {
					is: (solicitorDetailSearch, solicitorNotaMember) => (!solicitorDetailSearch || solicitorDetailSearch === {}) && solicitorNotaMember !== true,
					then: Yup.boolean().required(solicitorDetailErrorMessage),
					otherwise: Yup.boolean().notRequired().nullable()
				}),
				solicitorDetail: Yup.object({
					'email': Yup.string().email().nullable(),
                    'telephoneNo': phoneLocalOnly().required(),
					'lawAssociationName': alphanumWithSpecial().required(),
					'lawAssociationId': alphanumWithSpecial().notRequired().nullable(),
					'reference': alphanumWithSpecial().notRequired().nullable(),
					'addressLine1': requiredWhenNotVerified(Yup.string()),
					'addressLine2': requiredWhenNotVerified(Yup.string()),
					'addressLine3': alphanumWithSpecial().notRequired().nullable(),
					'addressLine4': alphanumWithSpecial().notRequired().nullable(),
					'town': alpha().notRequired().nullable(),
					'postcode': requiredWhenNotVerified(postcode()),
					'isVerified': Yup.boolean().required(),
					'officeId': Yup.string().notRequired().nullable()
				}).required(),
				confirmation: Yup.boolean().oneOf([true], formAgreementErrorMessage).required(formAgreementErrorMessage)
			})

			const customerDetailsField = fields.customerDetails && fields.customerDetails['fields']
			const customers = ref([])

			const addCustomer = function () {
				customers.value.push(customerDetailsField)
			}

			const removeCustomer = function (idx) {
				customers.value.splice(idx, 1)
			}

			onMounted(() => {
				customers.value.push(customerDetailsField)
				setTimeout(reset, 0)
			})

			const verifySolicitorSearch = function () {
				if (values.value.solicitorScotlandNIreland !== true && values.value.solicitorNotaMember !== true
					&& (values.value.solicitorDetailSearch === null || values.value.solicitorDetailSearch === {} || values.value.solicitorDetailSearch === undefined)) {
					setSolicitorErrorMessage(solicitorDetailErrorMessage);
				} else {
					setSolicitorErrorMessage('');
				}
			}

			const makeCustomerDetailsLabel = function (idx, field) {
				const required = field['required'] ? '*' : ''
				return idx >= 1 ? 'Customer ' + (idx + 1) + ' ' + field.label + required : 'Customer\'s ' + field.label + required
			}

			const nullableString = str => str ? String(str) : null

			const onSolicitorSelect = function (data) {
				setFieldValue('solicitorDetail.lawAssociationName', data['name'])
				setFieldValue('solicitorDetail.lawAssociationId', nullableString(data['licenceNumber']))
				setFieldValue('solicitorDetail.licenseNumber', nullableString(data['licenceNumber']))
				setFieldValue('solicitorDetail.addressLine1', data['address1'])
				setFieldValue('solicitorDetail.addressLine2', data['address2'])
				setFieldValue('solicitorDetail.addressLine3', data['address3'])
				setFieldValue('solicitorDetail.addressLine4', data['address4'])
				setFieldValue('solicitorDetail.town', data['town'] || '')
				setFieldValue('solicitorDetail.postcode', data['postcode'])
				setFieldValue('solicitorDetail.officeId', data['officeId'])
				setFieldValue('solicitorDetail.isVerified', true)
				setFieldValue('solicitorScotlandNIreland', false)
				setFieldValue('solicitorNotaMember', false)

				setFieldValue('solicitorNotaMemberDisable', true);
				setFieldValue('solicitorScotlandNIrelandDisable', true);

				let newErrors = { ...errors.value }
				delete newErrors['solicitorScotlandNIreland']

				let firstNames = [];
                let lastNames = [];
				let newCustArray = [];
                if (values.value.customerDetails !== null && values.value.customerDetails !== undefined) {
                    values.value.customerDetails.forEach(
                        c => {
                            newCustArray.push(c);
                            firstNames.push(c.firstName);
                            lastNames.push(c.lastName);
                        });	
				}

				resetForm({
					values: {
						...values.value,
						solicitorDetail: {
				            ...values.value.solicitorDetail
                        },
                        propertyDetail: {
                            ...values.value.propertyDetail
                        },
                        customerDetails:
                            newCustArray
                    },
					errors: newErrors
				});


                for (let i = 0; i < firstNames.length; i++) {
                    setFieldValue('customerDetails[' + i + '].firstName', firstNames[i]);
                    setFieldValue('customerDetails[' + i + '].lastName', lastNames[i]);
                }

			}

			const onSolicitorManualEntryChange = function (event) {
				let newErrors = { ...errors.value }

				verifySolicitorSearch();
				const keys = [
					'solicitorDetail.lawAssociationName',
					'solicitorDetail.lawAssociationId',
					'solicitorDetail.licenseNumber',
					'solicitorDetail.addressLine1',
					'solicitorDetail.addressLine2',
					'solicitorDetail.addressLine3',
					'solicitorDetail.addressLine4',
					'solicitorDetail.town',
					'solicitorDetail.postcode',
					'solicitorDetail.officeId',
					'solicitorDetail.isVerified'
				]

				keys.forEach(k => delete newErrors[k]);
				delete newErrors['solicitorNotaMember'];

				setFieldValue('solicitorNotaMemberDisable', values.value.solicitorScotlandNIreland);
				setFieldValue('solicitorDetail.isVerified', false);

				let firstNames = [];
				let lastNames = [];
                let newCustArray = [];
                if (values.value.customerDetails !== null && values.value.customerDetails !== undefined) {
                    values.value.customerDetails.forEach(
                        c => {
                            newCustArray.push(c);
                            firstNames.push(c.firstName);
                            lastNames.push(c.lastName);
                        });
                }						

				resetForm({
					values: {
						...values.value,
						solicitorDetailSearch: null,
						solicitorDetail: {
							isVerified: false,
							telephoneNo: values.value.solicitorDetail['telephoneNo'],
							email: values.value.solicitorDetail['email'],
							reference: values.value.solicitorDetail['reference'],
						},
						propertyDetail: {
							...values.value.propertyDetail
						},
						customerDetails:
							newCustArray
					},
                    errors: newErrors
				});

				for (let i = 0; i < firstNames.length; i++) {
					setFieldValue('customerDetails[' + i + '].firstName', firstNames[i]);
                    setFieldValue('customerDetails[' + i + '].lastName', lastNames[i]);
				}

				solicitorSearchNumber.value = ''
			}

			const onSolicitorNotaMemberChange = function (event) {
				let newErrors = { ...errors.value }				
				verifySolicitorSearch();

				const keys = [
					'solicitorDetail.lawAssociationName',
					'solicitorDetail.lawAssociationId',
					'solicitorDetail.licenseNumber',
					'solicitorDetail.addressLine1',
					'solicitorDetail.addressLine2',
					'solicitorDetail.addressLine3',
					'solicitorDetail.addressLine4',
					'solicitorDetail.town',
					'solicitorDetail.postcode',
					'solicitorDetail.officeId',
					'solicitorDetail.isVerified',
					'solicitorDetail.telephoneNo',
					'solicitorDetail.email',
					'solicitorDetail.reference'
				]

				keys.forEach(k => delete newErrors[k]);
				delete newErrors['solicitorScotlandNIreland'];

				setFieldValue('solicitorScotlandNIrelandDisable', values.value.solicitorNotaMember);

                let firstNames = [];
                let lastNames = [];
                let newCustArray = [];
                if (values.value.customerDetails !== null && values.value.customerDetails !== undefined) {
                    values.value.customerDetails.forEach(
                        c => {
                            newCustArray.push(c);
                            firstNames.push(c.firstName);
                            lastNames.push(c.lastName);
                        });
                }

				resetForm({
					values: {
						...values.value,
						solicitorDetailSearch: null,
						solicitorDetail: {
							isVerified: false,
                        },
                        propertyDetail: {
                            ...values.value.propertyDetail
                        },
                        customerDetails:
                            newCustArray
					},
					errors: newErrors
				})

                for (let i = 0; i < firstNames.length; i++) {
                    setFieldValue('customerDetails[' + i + '].firstName', firstNames[i]);
                    setFieldValue('customerDetails[' + i + '].lastName', lastNames[i]);
                }

				solicitorSearchNumber.value = '';
			}

			const setSolicitorErrorMessage = function (message) {
				solicitorErrorMessage.value = message;
			}

			return {
				isDebug,
				onSubmit,
				handleSubmit,
				submitCount,
				setErrors,
				errors,
				handleReset,
				isSubmitting,
				meta,
				values,
				isValid,
				schema,
				errs,
				props,
				fields,
				labels,
				customers,
				addCustomer,
				removeCustomer,
				makeCustomerDetailsLabel,
				selectedSolicitor,
				solicitorScotlandNIreland,
				onSolicitorSelect,
				onSolicitorManualEntryChange,
				onSolicitorNotaMemberChange,
				solicitorSearchNumber,
				submitErrorMessage,
				redeemedMessage,
				loading,
				solicitorErrorMessage,
                setSolicitorErrorMessage
			}
		}
	}


</script>



